module.exports = "<jhi-header></jhi-header> <main class=\"container-fluid\" id=\"main\" tabindex=\"-1\"> <div class=\"card jh-card transparent\"> <router-outlet></router-outlet> <router-outlet name=\"popup\"></router-outlet> </div> </main> <jhi-footer></jhi-footer>";


//////////////////
// WEBPACK FOOTER
// ./src/main/webapp/app/layouts/main/main.component.html
// module id = 513
// module chunks = 0